import {
  BaseEntityDTO,
  CriteriaDTO,
  IBaseEntityDTO,
  ICriteriaDTO,
  ITeamCriteriaDTO,
  TeamCriteriaDTO,
} from './';

export interface ITeamCriteriaSelectionDTO extends IBaseEntityDTO {
  teamCriteria?: ITeamCriteriaDTO;
  criteria?: ICriteriaDTO;
  mandatory: boolean;
  use_of_criteria: string;
}

export class TeamCriteriaSelectionDTO extends BaseEntityDTO implements ITeamCriteriaSelectionDTO {
  teamCriteria?: ITeamCriteriaDTO;
  criteria?: ICriteriaDTO;
  mandatory: boolean;
  use_of_criteria: string;

  constructor(data?: Partial<TeamCriteriaSelectionDTO>) {
    super(data);
    this.mandatory = data?.mandatory ?? false;
    this.use_of_criteria = data?.use_of_criteria ?? '';
    this.teamCriteria = data?.teamCriteria ? new TeamCriteriaDTO(data.teamCriteria) : undefined;
    this.criteria = data?.criteria ? new CriteriaDTO(data.criteria) : undefined;
  }
}
